import React, { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import { config } from 'src/constants/app'
import { PATH as ERROR_PATH } from 'src/pages/error'

const ShortLinkRedirect: React.FC = () => {
  const { token } = useParams()
  const navigate = useNavigate()

  useEffect(() => {
    if (!token || !config.baseURL) {
      navigate(ERROR_PATH.STATUS_ERROR, { replace: true })
      return
    }

    const baseUrl = String(config.baseURL).replace(/\/$/, '')
    // Relay web-domain short links to the API resolver so expiry, JWT creation, and final destination validation stay backend-owned.
    window.location.replace(`${baseUrl}/s/${encodeURIComponent(token)}`)
  }, [navigate, token])

  return null
}

export const PATH = '/s/:token' as const
export default ShortLinkRedirect
